import ServiceGraphQL from 'src/service/gql-service';
import { listCompanies } from 'src/graphql';
import { SettingsPageConfig } from 'src/config';

const serviceGraphQL = new ServiceGraphQL();

/** Action Types */
const SHOW_LOADING = 'SHOW_LOADING_COMPANIES';
const GET_DATA_SUCCESS = 'GET_DATA_COMPANIES_SUCCESS';
const SAVE_DATA_CURRENT_USER = 'SAVE_DATA_CURRENT_USER';

/** Actions */
export const showLoading = (loading) => ({
  type: SHOW_LOADING,
  loading
});

export const saveDataToRedux = (data, type = GET_DATA_SUCCESS) => ({
  type,
  data
});

/** Action creators */
export const GetListCompanies = (variables) => {
  return (dispatch) => {
    dispatch(showLoading(true));
    let params = {
      query: listCompanies.QUERY
    };

    if (variables) {
      params = {
        ...params,
        variables: {
          page: variables.pageIndex,
          perPage: variables.pageSize,
          ...variables
        }
      };
      delete params.variables.pageIndex;
      delete params.variables.pageSize;
    }

    return serviceGraphQL
      .post(params)
      .then((res) => {
        dispatch(showLoading(false));
        const { data } = res;
        if (data && data.companiesPagination) {
          const items = data.companiesPagination.items;
          const totalItems = data.companiesPagination.pageInfo.itemCount;
          const pageCount = data.companiesPagination.pageInfo.pageCount;

          let saveData = {
            items: items,
            totalItems: totalItems,
            pageCount: pageCount,
            pageIndex: SettingsPageConfig.pageIndex,
            pageSize: SettingsPageConfig.pageSize,
            filter: {}
          };

          if (variables) {
            saveData = {
              ...saveData,
              pageIndex: variables.pageIndex,
              pageSize: variables.pageSize,
              filter: variables.filter
            };
          }

          dispatch(saveDataToRedux(saveData));
        }
        return res;
      })
      .catch((err) => {
        dispatch(showLoading(false));
        throw err;
      });
  };
};

export const GetListCompaniesByCurrentUser = (variables) => {
  return (dispatch) => {
    dispatch(showLoading(true));
    let params = {
      query: listCompanies.QUERY,
      variables
    };

    return serviceGraphQL
      .post(params)
      .then((res) => {
        dispatch(showLoading(false));
        const { data } = res;
        if (data && data.companiesPagination) {
          const items = data.companiesPagination.items;
          dispatch(saveDataToRedux(items, SAVE_DATA_CURRENT_USER));
        }
        return res;
      })
      .catch((err) => {
        dispatch(showLoading(false));
        throw err;
      });
  };
};

// Initial state
export const initialState = {
  loading: false,
  items: [],
  totalItems: 0,
  pageCount: 0,
  pageIndex: 1,
  pageSize: 10,
  filter: {},
  companiesByCurrentUser: []
};

/** Reducers */
export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.loading
      };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.data.items,
        totalItems: action.data.totalItems,
        pageCount: action.data.pageCount,
        pageIndex: action.data.pageIndex,
        pageSize: action.data.pageSize,
        filter: action.data.filter
      };
    case SAVE_DATA_CURRENT_USER:
      return {
        ...state,
        loading: false,
        companiesByCurrentUser: action.data
      };
    default:
      return state;
  }
}
